module.exports = __webpack_public_path__ + "img/Temporary.8c490b3f.png";